module.exports = __webpack_public_path__ + "static/media/image_orange@2x-min.61120976.jpg";